
export enum ActionTypes {
    CANNED_MESSAGES = 'CANNED_MESSAGES',
    PERSONAL_CANNED_MESSAGES = 'PERSONAL_CANNED_MESSAGES',
    RESOURCES= 'RESOURCES',
    ALL_CANNED_MESSAGES="ALL_CANNED_MESSAGES"
}
